import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { TIME_FORMATS, DATE_FORMATS } from '../../../shared/utils/timeUtils';

@Component({
  selector: 'cc-history-date',
  templateUrl: './history-date.component.html',
  styleUrls: ['./history-date.component.scss']
})
export class HistoryDateComponent implements OnInit {
  @Input() date: string;
  @Input() time: string;
  public days: string;

  constructor() {}

  ngOnInit() {
    const expiredDate = moment(Date.parse(this.date));
    this.time = expiredDate.format(TIME_FORMATS.us);

    const todayStart = moment()
      .hour(0)
      .minute(0)
      .second(0);
    const yesterdayStart = moment()
      .subtract(1, 'days')
      .hour(0)
      .minute(0)
      .second(0);

    if (expiredDate.isAfter(todayStart)) {
      this.days = 'RECORDS_LIST.TODAY';
    } else if (expiredDate.isAfter(yesterdayStart)) {
      this.days = 'RECORDS_LIST.YESTERDAY';
    } else {
      this.days = expiredDate.format(DATE_FORMATS.us);
    }
  }
}
